export interface WorkspaceMetadata {
  voeColumnName?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export class Workspace {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly categoryMaxLevel: number,
    public readonly createdAt: Date,
    public readonly metadata: WorkspaceMetadata,
  ) {}
}
